// relative
import { apiSliceV2 } from '../../apiSlice';

export const locationsApiSlice = apiSliceV2.injectEndpoints({
  tagTypes: ['Location'],
  endpoints: (builder) => ({
    getLocationById: builder.query({
      query: ({ locationId }) => ({
        url: `/Locations/${locationId}`,
      }),
      providesTags: ['Location'],
    }),
    postLocation: builder.mutation({
      query: ({ location }) => ({
        url: `/Locations`,
        method: 'POST',
        body: location,
      }),
      invalidatesTags: ['Location'],
    }),
    putLocation: builder.mutation({
      query: ({ locationId, ...body }) => ({
        url: `/Locations/${locationId}`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['Location'],
    }),
  }),
});

export const {
  useGetLocationByIdQuery,
  useLazyGetLocationByIdQuery,
  usePostLocationMutation,
  usePutLocationMutation,
} = locationsApiSlice;
